import { motion } from "framer-motion";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { ExternalLink } from "lucide-react";

const itemVariants = {
  hidden: { y: 50, opacity: 0 },
  show: { y: 0, opacity: 1 }
};

export const NetworkCard = ({ site, index }) => {
  return (
    <motion.div variants={itemVariants} data-testid={`network-card-${index}`}>
      <Card className="modern-card rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 h-full hover:border-[hsl(var(--primary))]/50 transition-all group">
        <div className="space-y-4">
          <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${site.color} flex items-center justify-center text-white shadow-lg glow`}>
            {site.icon}
          </div>

          <h3
            className="font-display text-2xl font-bold text-[hsl(var(--foreground))] group-hover:text-[hsl(var(--primary))] transition-colors"
            data-testid={`network-name-${index}`}
          >
            {site.name}
          </h3>

          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed" data-testid={`network-description-${index}`}>
            {site.description}
          </p>

          <Button
            asChild
            className="modern-button w-full rounded-xl bg-[hsl(var(--primary))]/10 border border-[hsl(var(--primary))]/20 text-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/20 hover:border-[hsl(var(--primary))]/40 font-semibold text-sm py-6 transition-all group-hover:glow"
            data-testid={`network-visit-btn-${index}`}
          >
            <a href={site.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2">
              Visit Site
              <ExternalLink className="w-4 h-4" />
            </a>
          </Button>
        </div>
      </Card>
    </motion.div>
  );
};
